module.exports = "../../app/cells/components/countdown_cell.rb";